import React from 'react'
import ErrorIcon from '@mui/icons-material/Error'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

const DropzoneRejectedContent: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <ErrorIcon sx={{ color: 'common.white' }} />
      <Typography sx={{ marginTop: 0.5, textAlign: 'center', color: 'common.white' }} variant="body2">
        {t('file-add-error-text')}
      </Typography>
    </>
  )
}

export default DropzoneRejectedContent
